module.exports = "/_next/static/images/Key@2x-45cd0e79c600e95c39b31d6ebfbcee6d.png";